import styled, { DefaultTheme } from 'styled-components';
import { Button, Typography } from 'antd';

declare module 'styled-components' {
  export interface DefaultTheme {
    mode?: 'light' | 'dark';
  }
}

const getThemeValue = <T,>(props: { theme?: DefaultTheme }, darkValue: T, lightValue: T): T => {
  return props.theme?.mode === 'dark' ? darkValue : lightValue;
};

export const Wrapper = styled.div`
  height: 100%;
  min-height: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: ${(props) => getThemeValue(props, '#0d1117', '#f5f7fa')};
  padding: 24px;
  box-sizing: border-box;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 24px;
  max-width: 420px;
  padding: 48px 40px;
  border-radius: 16px;
  border: 1px solid ${(props) => getThemeValue(props, '#30363d', '#e8e8e8')};
  background: ${(props) => getThemeValue(props, '#161b22', '#ffffff')};
  box-shadow: ${(props) =>
    getThemeValue(props, '0 8px 24px rgba(0,0,0,0.25)', '0 4px 16px rgba(0,0,0,0.08)')};

  @media (max-width: 768px) {
    padding: 32px 24px;
    gap: 20px;
  }
`;

export const Title = styled(Typography.Title)`
  margin: 0 !important;
  font-size: 72px !important;
  line-height: 1 !important;
  font-weight: 700 !important;
  color: ${(props) => getThemeValue(props, '#f87171', '#dc2626')} !important;
  letter-spacing: -2px;

  @media (max-width: 768px) {
    font-size: 56px !important;
  }
`;

export const Subtitle = styled(Typography.Text)`
  font-size: 16px;
  color: ${(props) => getThemeValue(props, '#8b949e', '#595959')} !important;
  line-height: 1.5;
  display: block;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const StyledButton = styled(Button)`
  margin-top: 8px;
  border-radius: 8px;
  font-weight: 500;
  height: 44px;
  padding-left: 20px;
  padding-right: 20px;
  border: 1px solid ${(props) => getThemeValue(props, '#2dd4bf', '#2c7a7b')};
  background: ${(props) => getThemeValue(props, '#319795', '#2c7a7b')};
  color: #fff !important;

  &:hover:not(:disabled) {
    background: ${(props) => getThemeValue(props, '#38b2ac', '#285e61')} !important;
    border-color: ${(props) => getThemeValue(props, '#2dd4bf', '#285e61')} !important;
    color: #fff !important;
  }

  .anticon {
    margin-right: 8px;
  }
`;

export const IconWrap = styled.span`
  margin-right: 8px;
  display: inline-flex;
  align-items: center;
`;
